<template>
  <v-container class="pa-3" style="max-width: 100% !important">
    <v-row no-gutters>
      <!-- Navigation Column -->
      <v-col cols="12" md="2">
        <v-list class="bg-grey-lighten-4">
          <v-list-item
            v-for="(item, index) in navItems"
            :key="index"
            :value="item"
            :active="selectedItem === item"
            @click="selectedItem = item"
            density="compact"
          >
            <template v-slot:prepend>
              <v-icon :icon="item.icon"></v-icon>
            </template>

            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-col>

      <!-- Content Column -->
      <v-col cols="12" md="10">
        <component
          :is="selectedItem?.component"
          v-if="selectedItem?.component"
        />
        <v-card v-else class="ma-2">
          <v-card-text>Please select an item from the navigation</v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DevopsErrorLogs from "./DevopsErrorLogs.vue";

export default {
  name: "DevopsLogs",
  components: {
    DevopsErrorLogs,
  },
  data: () => ({
    selectedItem: null,
    navItems: [
      {
        title: "Error Logs",
        component: "DevopsErrorLogs",
        icon: "mdi-alert-circle",
      },
      {
        title: "System Logs",
        component: null,
        icon: "mdi-server",
      },
      {
        title: "Application Logs",
        component: null,
        icon: "mdi-package",
      },
    ],
  }),
  mounted() {
    // Set default selected item
    if (this.navItems.length > 0) {
      this.selectedItem = this.navItems[0];
    }
  },
};
</script>

<style scoped>
.v-list-item--active {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
